import { Component, HostListener, OnInit, Input } from '@angular/core';
import { NewStoryService } from '../new';
import { Store } from '@ngrx/store';
import * as fromApp from '../../app.reducer';
import * as newActions from '../new/store/new.actions';
import { UploadStatus } from '../new/store/new.reducer';

@Component({
  selector: 'upload-progress',
  styleUrls: [],
  templateUrl: './uploadProgress.component.html',
})
export class UploadProgressComponent implements OnInit {
  public showConfirmCancelUpload;
  cancelUploadingConfirmationMessage;
  submitting;
  mouseLeaved;
  uploadStatus: UploadStatus;
  isWizardPage;
  @Input() isContibution;
  @Input() isDesigning;

  @HostListener('window:beforeunload', ['$event'])
  preventCancelUpload($event) {
    this.preventLeave($event);
  }

  @HostListener('document:mouseleave', ['$event'])
  onMouseLeave() {
    if (this.uploadStatus.status === 'uploading' && !this.mouseLeaved) {
      this.store.dispatch(new newActions.MouseLeaved());
    }
  }

  constructor(
    private newStoryService: NewStoryService,
    private store: Store<fromApp.AppState>
  ) {}

  ngOnInit() {
    this.store.select('new').subscribe(store => {
      this.submitting = store.submitting;
      this.uploadStatus = store.uploadStatus;
      this.mouseLeaved = store.mouseLeaved;
    });
    this.store.select('shared').subscribe(store => {
      this.isWizardPage = store.currentPage === 'wizardPage';
    });
  }

  preventLeave($event) {
    if (this.isOrderSubmitting) {
      $event.returnValue = this.cancelUploadingConfirmationMessage;
      return this.cancelUploadingConfirmationMessage;
    }
  }

  get isOrderSubmitting() {
    return this.submitting;
  }

  showCancelUploadModal() {
    this.showConfirmCancelUpload = true;
  }

  confirmCancelUploading() {
    this.newStoryService.cancelUploading();
    this.showConfirmCancelUpload = false;
  }

  continueUploading() {
    this.showConfirmCancelUpload = false;
  }
}
